// Modules
import React, { useEffect } from 'react'
import { Redirect, useHistory } from 'react-router-dom'

// Application
import { useSignUp } from 'context'
import { ROUTES_PATH } from 'constants/index'
import { isEmpty } from 'utils'
import { useSignUpStepper } from 'redesign/hooks/useSignUpStepper'
import { useSignUpAnaytics } from 'hooks/useSignUpAnaytics'

// Components
import { TemplateContainer } from 'components'
import { NewPasswordSimplified } from 'components/Presenters/NewPasswordSimplified'
import { NewPassword, NewPasswordInitial } from 'components/Presenters/NewPassword'
import { SignUpHeader as Header } from 'redesign/components/organisms'
import { useRemoteConfig } from 'modules/RemoteConfig/hooks/useRemoteConfig'

export const SNCreatePassword: React.FC = () => {
    const history = useHistory()
    const { isFeatureEnabled } = useRemoteConfig()
    const { hasMounted, hasSeenFirstStep, setPassword, setIsLoading, userId, personalData } = useSignUp()
    const { setStepValue } = useSignUpStepper()
    const shouldRedirect = !personalData?.cpf || !personalData.biologicalSex || !hasSeenFirstStep
    const isPasswordSimplifiedActivated = isFeatureEnabled('AUTH_PASSWORD_SIMPLIFICATION')

    useSignUpAnaytics({
        defaultDispatchEvent: 'passwordOnOpen',
        shouldCall: hasMounted && !shouldRedirect,
    })

    useEffect(() => {
        setStepValue(1)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (!hasMounted) {
        return null
    }

    if (shouldRedirect) {
        return <Redirect to={ROUTES_PATH.SIGN_UP_PERSONAL_DATA} />
    }

    const handleSubmit = async (values: NewPasswordInitial, setFieldError: (field: string, value: string | undefined) => void) => {
        try {
            setIsLoading(true)
            await setPassword(values)

            if (!isEmpty(userId)) {
                return history.push(ROUTES_PATH.SIGN_UP_SELECT_CONTACT)
            }
            return history.push(ROUTES_PATH.SIGN_UP_PHONE)
        } catch {
            setFieldError('confirmPassword', 'Ocorreu um erro. Tente novamente mais tarde')
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <TemplateContainer>
            <Header showStepper subtitle="Inclua os requisitos listados abaixo para criar uma senha segura:" title="Crie uma senha" />

            {isPasswordSimplifiedActivated ? (
                <NewPasswordSimplified handleSubmit={handleSubmit} initialValues={{ password: '', confirmPassword: '' }} />
            ) : (
                <NewPassword handleSubmit={handleSubmit} initialValues={{ password: '', confirmPassword: '' }} />
            )}
        </TemplateContainer>
    )
}
